export class MISMODate {
    constructor(sDate) {
        this.Month = 0;
        this.Day = 0;
        this.Year = 0;
        this.TimeZone = '';

        // format CCYY-MM-DD {Z} | {+hh:mm} | {-hh:mm}
        if (!sDate) return;
        if (sDate === "") return;

        const parts = sDate.split('-');
        this.Year = parseInt(parts[0], 10);

        if (parts.length >= 2) {
            this.Month = parseInt(parts[1], 10);
        }
        if (parts.length >= 3) {
            this.Day = parseInt(parts[2], 10);
        }
    }

    HasFullDate() {
        return this.Year !== 0 && this.Month !== 0 && this.Day !== 0;
    }

    HasMonthYear() {
        return this.Year !== 0 && this.Month !== 0;
    }

    IsLaterThan(dt) {
        if (dt.Year < this.Year) return true;
        if (dt.Year > this.Year) return false;
        if (dt.Month < this.Month) return true;
        if (dt.Month > this.Month) return false;
        if (dt.Day < this.Day) return true;

        return false;
    }

    IsBefore(dt, bIgnoreDay = false) {
        if (dt.Year > this.Year) return true;
        if (dt.Year < this.Year) return false;
        if (dt.Month > this.Month) return true;
        if (dt.Month < this.Month) return false;
        if (!bIgnoreDay && dt.Day > this.Day) return true;

        return false;
    }

    IsFuture() {
        const now = new Date();
        if (now.getFullYear() < this.Year) return true;
        if (now.getFullYear() > this.Year) return false;
        if (now.getMonth() + 1 < this.Month) return true; // JS months are 0-indexed
        if (now.getMonth() + 1 > this.Month) return false;
        if (now.getDate() < this.Day) return true;

        return false;
    }

    MoreThanYearOld() {
        const now = new Date();
        if (now.getFullYear() + 1 < this.Year) return true;
        if (now.getFullYear() + 1 > this.Year) return false;
        if (now.getMonth() + 1 < this.Month) return true; // JS months are 0-indexed
        if (now.getMonth() + 1 > this.Month) return false;
        if (now.getDate() < this.Day) return true;

        return false;
    }

    DaysOld() {
        const today = new Date();
        const date = new Date(this.Year, this.Month - 1, this.Day); // JS months are 0-indexed

        const timeDiff = today.getTime() - date.getTime();
        return Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    }

    FormatMDY() {
        // Year | Month/Year | Month/Day/Year | Month/Day
        if (this.Year > 0) {
            if (this.Month > 0) {
                if (this.Day > 0) {
                    return `${this.Month.toString().padStart(2, '0')}/${this.Day.toString().padStart(2, '0')}/${this.Year.toString().padStart(4, '0')}`;
                } else {
                    return `${this.Month.toString().padStart(2, '0')}/${this.Year.toString().padStart(4, '0')}`;
                }
            }
            // If no month, then there should not be a day
            return this.Year.toString().padStart(4, '0');
        }

        if (this.Month > 0) { // I don't think this will ever happen, but ...
            if (this.Day > 0) {
                return `${this.Month.toString().padStart(2, '0')}/${this.Day.toString().padStart(2, '0')}`;
            }
        }
        return '';
    }
}
